export const manifestLocales = {
  video: {
    previewImageAlt: {
      en: 'video widget',
      he: 'וידיאו'
    }
  }
};
